const DefaultRequestConst = {
    asc: false,
    limit: 250,
    page: 0,
    sort: 'date',
};

export default DefaultRequestConst;